<seds-modal>
  <div header>Redefinição de senha do usuário</div>
  <div content class="dialog-content__fade-in">
    @if (resetStatus.value === 'success') {
      <pl-alert color="success" display="block">
        <span header>Senha redefinida com sucesso</span>
        <span content>Uma senha temporária foi enviada ao e-mail do usuário</span>
      </pl-alert>
    }

    <div>
      @if (resetStatus.value === 'error') {
        <pl-alert color="error"  display="block">
          <span header>Não foi possível redefinir a senha do usuário</span>
          <span content>{{ messageAlert }}</span>
        </pl-alert>
      }

      @if (!isAllowedToResetPassword) {
        <pl-alert class="dialog-content__alert">
          <span header></span>
          <span content>Para redefinir a senha desse usuário é necessário atualizar seus dados cadastrais.</span>
        </pl-alert>
      }

      @if (isAllowedToResetPassword && resetStatus.value === 'default') {
        <p
          class="dialog-content__description"
          >
          Confirma a redefinição de senha do usuário abaixo? Um e-mail com uma senha
          temporária será enviado ao e-mail cadastrado.
        </p>
      }

      <section class="dialog-content__box">
        <ul class="dialog-content__box__list">
          <li class="dialog-content__box__list__item">
            Nome:
            <span
            [ngClass]="{
              'dialog-content__box__list__item--bold': data?.fullname,
              'dialog-content__box__list__item--italic': !data?.fullname
            }"
              >{{ data?.fullname || 'Não cadastrado' }}</span
              >
            </li>
            <li>
              {{ data?.document?.documentCountry !== 'BRA' ? 'RNM' : 'CPF' }}:
              <span
            [ngClass]="{
              'dialog-content__box__list__item--bold':
                data?.document?.documentId,
              'dialog-content__box__list__item--italic':
                !data?.document?.documentId
            }"
                >{{
                (data?.document?.documentId | document : true) || 'Não cadastrado'
                }}</span
                >
              </li>
              <li>
                Logon:
                <span
            [ngClass]="{
              'dialog-content__box__list__item--bold': data?.logon,
              'dialog-content__box__list__item--italic': !data?.logon
            }"
                  >{{ data?.logon || 'Não cadastrado' }}</span
                  >
                </li>
                <li>
                  E-mail:
                  <label
            [ngClass]="{
              'dialog-content__box__list__item--bold':
                data?.alternativeEmail?.email,
              'dialog-content__box__list__item--italic':
                !data?.alternativeEmail?.email
            }"
                    >{{ data?.alternativeEmail?.email || 'Não cadastrado' }}</label
                    >
                  </li>
                  <li>
                    Celular:
                    <span
            [ngClass]="{
              'dialog-content__box__list__item--bold': data?.phone,
              'dialog-content__box__list__item--italic': !data?.phone
            }"
                      >{{ data?.phone?.areaCode }}
                      {{ data?.phone?.phoneNumber || 'Não cadastrado' }}</span
                      >
                    </li>
                  </ul>
                </section>
              </div>
            </div>
            <div class="footer w-100 d-flex justify-content-end" footer>
              @if (isAllowedToResetPassword && resetStatus.value === 'default') {
                <seds-flat-button
                  class="btn-cancelar__fade-in"
                  data-test="btn-cancelar"
                  launchLabel="Não, manter senha"
                  launchSection="Clique"
                  launchSiteSection="PortalDeLogons"
                  mat-dialog-close
                  plAnalyticsButton
                  title="Não, manter senha"
                ></seds-flat-button>
                <seds-basic-button
                  (click)="resetPassword()"
                  [size]="smallButton"
                  class="btn-redefinir-senha__fade-in"
                  data-test="btn-redefinir-senha"
                  launchLabel="Sim, redefinir senha"
                  launchSection="Clique"
                  launchSiteSection="PortalDeLogons"
                  plAnalyticsButton
                  title="Sim, redefinir senha"
                ></seds-basic-button>
              }

              @if (!isAllowedToResetPassword && resetStatus.value === 'default') {
                <seds-flat-button
                  class="btn-cancelar__fade-in"
                  data-test="btn-cancelar"
                  launchLabel="Cancelar"
                  launchSection="Clique"
                  launchSiteSection="PortalDeLogons"
                  mat-dialog-close
                  plAnalyticsButton
                  title="Cancelar"
                ></seds-flat-button>
                <seds-basic-button
                  (click)="editUser()"
                  [size]="smallButton"
                  class="btn-editar-usuario__fade-in"
                  data-test="btn-editar-usuario"
                  launchLabel="Editar usuário"
                  launchSection="Clique"
                  launchSiteSection="PortalDeLogons"
                  mat-dialog-close
                  plAnalyticsButton
                  title="Editar usuário"
                ></seds-basic-button>
              }


              @if (
                isAllowedToResetPassword &&
                (resetStatus.value === 'success' || resetStatus.value === 'error')
                ) {
                <seds-basic-button
                  class="btn-concluir__fade-in"
                  data-test="btn-concluir"
                  mat-dialog-close
                  [size]="smallButton"
                  title="Concluir"
                  (click)="done()"
                  launchLabel="Concluir"
                  launchSection="Clique"
                  launchSiteSection="PortalDeLogons"
                  plAnalyticsButton
                ></seds-basic-button>
              }
            </div>
          </seds-modal>
